import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

/** Tailwind 友好的 className 合并：clsx 处理条件类，tailwind-merge 去重冲突 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs))
}
